import React, { FunctionComponent } from 'react';
import { LoaderSpinner, sizes} from '../LoaderSpinner';
import { AppHead } from '../AppHead';

interface LoaderWithHeaderProps {
    size?: keyof typeof sizes;
}

// LoaderWithHeader is a component that displays an error message with the app header in a consistent layout.
export const LoaderWithHeader: FunctionComponent<LoaderWithHeaderProps> = ({size="medium"}) => {
  return (
    <div className="relative min-h-screen">
      <AppHead />
      <div className="flex min-h-screen items-center justify-center p-4 pt-10">
        <LoaderSpinner size={size} />
      </div>
    </div>
  );
};
